module.exports = __webpack_public_path__ + "img/logo-fixed.e0c93225.svg";